import { coreLettersAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';
import { GlobalLetter } from '../types';

type GlobalLetterResponse = {
  success: boolean;
  message: string;
  data: GlobalLetter;
};

type Return = GlobalLetter;

export type GetGlobalLetterTemplate = {
  response: GlobalLetterResponse;
  return: Return;
};

export const getGlobalLetterTemplate = withLogger(async (): Promise<Return> => {
  const url = globalLetterAPIUrls.templates;

  const {
    data: { data },
  } = await coreLettersAxiosClient.get<GlobalLetterResponse>(url);

  return data;
});
